import clsx from "clsx";
import ArticleCard from "components/organism/Cards/ArticleCard";
import { articleList } from "data";
import { Fragment } from "react";

const ArticleSection = () => {
    return (
        <Fragment>
            <div className="w-full bg-neutral-20">
                <section className={clsx(
                    "max-w-[1440px] mx-auto",
                    "py-[88px] tablet:py-16 phone:py-12 px-6 tablet:px-8 desktop:px-[120px]",
                    "grid grid-cols-1 md:grid-cols-3 tablet:gap-6 gap-8 phone:gap-6 mt-[32px]"
                )}>
                    {articleList.map((item) => (
                        <ArticleCard key={item.id} icons={item.icons} title={item.title} description={item.description} />
                    ))}
                </section>
            </div>
        </Fragment>
    );
};

export default ArticleSection;